var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wecoupon-mall-couponcard"},[_c('CouponItem',{attrs:{"amountSize":32,"data":_vm.couponInfo},on:{"btnClick":function($event){return _vm.$emit('btnClick')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }